// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimActivitiesViewDto
 */
export interface IClaimActivitiesViewDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimActivitiesViewDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivitiesViewDto
     */
    provider_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivitiesViewDto
     */
    category_type?: IClaimActivitiesViewDtoCategoryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivitiesViewDto
     */
    requested_amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof IClaimActivitiesViewDto
     * @deprecated
     */
    service_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimActivitiesViewDto
     */
    local_date_service_on?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IClaimActivitiesViewDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the IClaimActivitiesViewDto interface.
 */
export function instanceOfIClaimActivitiesViewDto(value: object): value is IClaimActivitiesViewDto {
    return true;
}

export function IClaimActivitiesViewDtoFromJSON(json: any): IClaimActivitiesViewDto {
    return IClaimActivitiesViewDtoFromJSONTyped(json, false);
}

export function IClaimActivitiesViewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimActivitiesViewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'provider_name': json['provider_name'] == null ? undefined : json['provider_name'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'requested_amount': json['requested_amount'] == null ? undefined : json['requested_amount'],
        'service_on': json['service_on'] == null ? undefined : (new Date(json['service_on'])),
        'local_date_service_on': json['local_date_service_on'] == null ? undefined : (new Date(json['local_date_service_on'])),
    };
}

export function IClaimActivitiesViewDtoToJSON(json: any): IClaimActivitiesViewDto {
    return IClaimActivitiesViewDtoToJSONTyped(json, false);
}

export function IClaimActivitiesViewDtoToJSONTyped(value?: IClaimActivitiesViewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'provider_name': value['provider_name'],
        'category_type': value['category_type'],
        'requested_amount': value['requested_amount'],
        'service_on': value['service_on'] == null ? undefined : ((value['service_on']).toISOString()),
        'local_date_service_on': value['local_date_service_on'] == null ? undefined : ((value['local_date_service_on']).toISOString().substring(0,10)),
    };
}

